// are you looking for config settings?  Try looking in the assets/config folder
// assets/config/live/config.json is by default your local environment - this file gets overwritten on deployments by the appropriate env.ts file in the assets folder
// Also, make sure any NEW settings you create have a property established in the dynamic-environment.ts file and NOT this file.

import { DynamicEnvironment } from './dynamic-environment';

class Environment extends DynamicEnvironment {

  public production: boolean;
  
  constructor() {
    super();
    this.production = true;
  }
}

export const environment = new Environment();